import React from "react";

import { CONTACT, CONTACT_DETAILS, SECTIONS } from "../../data/content";
import { postRequest } from "../../utils/apiHandlers";
import SocialIcons from "../general/SocialIcons";

const EMPTY = {
  name: "",
  email: "",
  subject: "",
  phone: "",
  message: "",
  website: "", //Honeypot
};

//Wix only had placeholders - the labels are kept for screen readers
const Field = ({ label, className = "", children }) => (
  <label className={`contact-field ${className}`}>
    <span className={"visually-hidden"}>{label}</span>
    {children}
  </label>
);

const ContactSection = () => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [sentTo, setSentTo] = React.useState(null);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendContactMessage", form);
      setSentTo(form.name.split(" ")[0]);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  return (
    <section
      id={SECTIONS.CONTACT}
      className={"contact"}
      aria-labelledby={"contact-title"}
    >
      <div className={"contact-photo"}>
        <img
          src={CONTACT.IMAGE.src}
          alt={CONTACT.IMAGE.alt}
          width={1500}
          height={1000}
          loading={"lazy"}
        />
      </div>

      <div className={"contact-panel"}>
        <img
          src={"/images/logo.webp"}
          alt={""}
          width={600}
          height={423}
          className={"contact-logo"}
          loading={"lazy"}
        />
        <h2
          id={"contact-title"}
          className={"contact-title"}
        >
          {CONTACT.TITLE}
        </h2>
        <SocialIcons className={"contact-social"} />

        <address className={"contact-details"}>
          {CONTACT_DETAILS.NAME}
          <br />
          Tel: <a href={CONTACT_DETAILS.PHONE.link}>{CONTACT_DETAILS.PHONE.label}</a>
          <br />
          Email: <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
          <br />
          <br />
          <a
            href={CONTACT_DETAILS.MAP_LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
            aria-label={`${CONTACT_DETAILS.ADDRESS.join(", ")} (open in Google Maps)`}
          >
            {CONTACT_DETAILS.ADDRESS[0]}
            <br />
            {CONTACT_DETAILS.ADDRESS[1]}
          </a>
        </address>

        {sentTo !== null ? (
          <div
            className={"contact-success"}
            role={"status"}
          >
            <p>Thanks for your message{sentTo ? `, ${sentTo}` : ""}! We&apos;ll be in touch soon.</p>
            <button
              type={"button"}
              className={"contact-submit"}
              onClick={() => setSentTo(null)}
            >
              Send another message
            </button>
          </div>
        ) : (
          <form
            className={"contact-form"}
            onSubmit={onSubmit}
          >
            <Field label={"Name"}>
              <input
                type={"text"}
                value={form.name}
                onChange={update("name")}
                maxLength={200}
                autoComplete={"name"}
                placeholder={"Name"}
              />
            </Field>
            <Field label={"Email (required)"}>
              <input
                type={"email"}
                value={form.email}
                onChange={update("email")}
                required
                maxLength={200}
                autoComplete={"email"}
                placeholder={"Email *"}
              />
            </Field>
            <Field label={"Subject"}>
              <input
                type={"text"}
                value={form.subject}
                onChange={update("subject")}
                maxLength={200}
                placeholder={"Subject"}
              />
            </Field>
            <Field label={"Phone"}>
              <input
                type={"tel"}
                value={form.phone}
                onChange={update("phone")}
                maxLength={50}
                autoComplete={"tel"}
                placeholder={"Phone"}
              />
            </Field>
            <Field
              label={"Message (required)"}
              className={"is-wide"}
            >
              <textarea
                value={form.message}
                onChange={update("message")}
                required
                maxLength={5000}
                rows={5}
                placeholder={"Type your message here... *"}
              />
            </Field>
            <label
              className={"contact-honeypot"}
              aria-hidden={"true"}
            >
              Website
              <input
                type={"text"}
                value={form.website}
                onChange={update("website")}
                tabIndex={-1}
                autoComplete={"off"}
              />
            </label>

            {errorText ? (
              <p
                className={"contact-error"}
                role={"alert"}
              >
                {errorText}
              </p>
            ) : null}

            <button
              type={"submit"}
              className={"contact-submit"}
              disabled={isSending}
            >
              {isSending ? "Sending..." : "Submit"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
